import { IAjaxConfig } from '../libraries';
export class EnumApiLegal {
  /**
   * @dec 保存用户确认协议日志
   */
  readonly legal_portal_protocol_save: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/public/protocol/log/save',
    method: 'post',
  };

  /**
   * @dec 查询协议
   */
  readonly legal_portal_protocol_find: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-legal-inspect/v1/portal/public/protocol/find',
    method: 'get',
  };
}
